import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon } from '@/components';
import { RootStore, barrage } from '@/models';
import ActionBtn from '../ActionBtn';
import styles from './index.less';
import classNames from 'classnames';
import { elkLog } from '@/utils/elkReport';

interface Props extends Partial<Pick<RootStore, 'meeting'>> {
  meeting?: RootStore['meeting'];
}
const BarrageBtn: React.FC<Props> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    barrage: store.barrage,
  };
})(
  observer((props) => {
    const { meeting } = props;
    const { formatMessage } = useIntl();
    const openBarrage = () => {
      elkLog('点击字幕按钮');
      barrage.setBarrageVisible(!barrage.barrageVisible);
    };

    if (!meeting?.ableAppsMap.Subtitle) {
      return null;
    }
    return (
      <ActionBtn
        title={
          barrage.barrageVisible
            ? formatMessage({ id: 'disableSubtitles' })
            : formatMessage({ id: 'barrage' })
        }
        className={classNames(styles.BarrageBtn, barrage.barrageVisible ? styles.on : '')}
        onClick={openBarrage}
      >
        <Icon className={styles.icon} name="icon-cc_1" size={24} mode="symbol" />
      </ActionBtn>
    );
  })
);

export default BarrageBtn;
